import React from "react";
import { Tabs } from "antd";
import PurchasesTableDetails from "./tableDetails";
import AdminPurchaseContract from "./purchasesContract";


function PurchasesControl({ id, onDataUpdate, onCloseDrawer }) {
  const items = [
    {
      label: "جزییات خرید",
      key: "1",
      children: (
        <PurchasesTableDetails
          id={id}
          onDataUpdate={onDataUpdate}
          onCloseDrawer={onCloseDrawer}
        />
      ),
    },
    { label: "قرارداد", key: "2", children: <AdminPurchaseContract id={id}/> },
  ];
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
}

export default PurchasesControl;
